import {createAPIClient} from "@shopware/api-client";
import type {operationPaths, operations, Schemas} from "#shopware";
import {findObjectByType, removeCartItemsByIds} from "~/components/utilities";
import axios from "axios";
import Cookies from "js-cookie";

const shopwareEndpoint = "https://dev.luftkuss.ch/store-api/";
const shopwareAccessToken = "SWSCMHL2RHFKQXA3SFPQSW1UBW";

const apiClient = createAPIClient<operations, operationPaths>({
  accessToken: shopwareAccessToken,
  baseURL: shopwareEndpoint,
  defaultHeaders: {
    'sw-include-seo-urls': '1',
  }
});

export default apiClient;

export const getProductsByCategoryId = async (categoryId: any) => {

  try {
    const operationName = "readCategory post /category/" + categoryId;
    const body = {
      "associations": {
        "seoUrls": {}
      },
      "includes": {
        "category": ["id", "name", "cmsPage"],
        "cms_page": ["id", "sections"],
        "cms_section": ["pageId", "blocks"],
        "cms_block": ["sectionId", "slots", "type"],
        "cms_slot": ["blockId", "config", "data"],
        //"product": ["id", "name", "translated", "media", "seoUrl", "stock", "calculatedPrice", "available", "active"]
      }
    }

    const response = await apiClient.invoke(operationName, body);
    if (response) {
      return findObjectByType(response?.data.cmsPage, 'product-listing');
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export const getProductById = async (productId: any) => {
  try {
    const operationName = "readProductDetail post /product/" + productId;

    const response = await apiClient.invoke(operationName, {
      body: {
        "associations": {
          "media": {}
        }
      }
    });
    if (response) {
      return response?.data.product;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getProductList(categoryId: any, body: any) {
  try {

    const url = shopwareEndpoint + `product-listing/${categoryId}`;

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}
